import Image from 'next/image';

const HeroBanner = (props) => {
  const s = require('./herobanner.module.scss');
  const { date, title, category, blurb, image, fullname } = props;
  const newImage = image && image.large;
  return (
    <div className={s.Wrapper} id={props.slug}>
        <div className={s.Container}>
          {image &&
          <div className={s.Image} style={{ background: `url(${image.large}) no-repeat center` }}>
            <Image
              src={newImage}
              alt={title}
              style={{ opacity: 0 }}
              width="100%"
              height={307}
            />
          </div>}
          <div className={s.Content}>
            <div className={s.Date}>
              <div>{category}</div>
            </div>
            <div className={s.Category}>
              <div>{date}</div>
              <p>{fullname}</p>
            </div>
            <div className={s.Title}>
              <h1>{title}</h1>
            </div>
            <div className={s.Paragraph} dangerouslySetInnerHTML={{ __html: blurb }}></div>
          </div>
        </div>
      </div>
  )
}

export default HeroBanner;